import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = { class: "payment_confirm" };
const _hoisted_3 = { class: "spinner-container" };
const _hoisted_4 = { class: "spinner" };
const _hoisted_5 = { class: "message-box" };
const _hoisted_6 = { style: { "margin-top": "20px" } };
const _hoisted_7 = ["href"];
import { onMounted, ref } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'payment_confirm',
    props: {
        common: {},
        url: {},
        init_loading: {}
    },
    setup(__props) {
        const props = __props;
        const redirecting = ref(true);
        onMounted(() => {
            // 自動的に3DS2認証画面にリダイレクト
            setTimeout(() => {
                window.location.href = props.url;
            }, 1000); // 1秒後にリダイレクト（ユーザーにメッセージを見せるため）
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                                    _createElementVNode("strong", null, "3Dセキュア認証が必要です")
                                ], -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, "自動的に認証画面に移動します...", -1)),
                                _createElementVNode("p", _hoisted_6, [
                                    _cache[0] || (_cache[0] = _createTextVNode(" 自動的に移動しない場合は ")),
                                    _createElementVNode("a", {
                                        href: props.url,
                                        style: { "color": "blue", "text-decoration": "underline" }
                                    }, "こちら", 8, _hoisted_7),
                                    _cache[1] || (_cache[1] = _createTextVNode(" をクリックしてください。 "))
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
